import HomeComponent from '../Components/HomeComponents/HomeComponent'

function Home() {
  return <HomeComponent />
}

export default Home
